import MockImg from 'assets/img/shopping-cart-demo.png';
import PreConfigImg from 'assets/img/svc-demo/WX20220330-16503.png';
import { REACT_APP_DEMO_FLAG } from 'utils/constants';
import { getImage } from 'utils/gallery';
import './index.less';

interface Iprops {
  image?: string;
  skuName?: string;
}

const RevxJobImg = (props: Iprops) => {
  const { image, skuName } = props;

  return (
    <>
      <div className="job-img-container">
        {Boolean(image) && (
          <img
            src={
              REACT_APP_DEMO_FLAG
                ? skuName === 'Albertsons - Champion Poster'
                  ? PreConfigImg
                  : getImage(image || '')
                : getImage(image || '')
            }
            alt="none"
            onError={function (e) {
              const img = e.target as HTMLImageElement;
              // image?.split('.').pop()?.toLowerCase() === 'pdf'
              //   ? img.src = `${UPLOAD_FILE_THUMBNAIL_ADDRESS_PREFIX}${image}`
              //   : img.src = `${UPLOAD_FILE_ADDRESS_PREFIX}${image}`;
              img.src = MockImg;
            }}
          />
        )}
      </div>
    </>
  );
};

export default RevxJobImg;
